// Set global log level
const LOG_LEVEL = 'info';

function waitForSwiper(trigger) {
  var interval = setInterval(function () {
      if (typeof Swiper != "undefined") {
          clearInterval(interval);
          trigger();
      }
  }, 50);
  setTimeout(function () {
      clearInterval(interval);
  }, 15000)
}

function addScript() {
  var swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js';
  document.getElementsByTagName('head')[0].appendChild(swiperScript);
}

// ATC Button Initialization
function createLogger(isDebug, instanceName, level = 'info') {
  const colors = {
    debug: "#95a5a6",
    info: "#3498db",
    success: "#2ecc71",
    error: "#e74c3c",
  };

  const levels = {
    debug: 0,
    info: 1,
    success: 2,
    error: 3
  };

  const currentLevel = levels[level] || levels.info;

  const logFn = (type, ...args) => {
    // Only log if customElementDebug is true or if it's an error
    if ((theme.customElementDebug || type === 'error') && levels[type] >= currentLevel) {
      console.log(
        `%cFD-${instanceName}`,
        `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
        ...args
      );
    }
  };

  return {
    debug: (...args) => logFn("debug", ...args),
    info: (...args) => logFn("info", ...args),
    success: (...args) => logFn("success", ...args),
    error: (...args) => logFn("error", ...args),
  };
}

document.addEventListener("DOMContentLoaded", (event) => {
  const logger = createLogger(true, 'init', LOG_LEVEL);
  logger.info("DOM Content Loaded - Initializing custom functionality");
  
  // Wait for custom elements to be defined
  customElements.whenDefined('custom-color-options').then(() => {
    logger.info("Custom color options element defined");
  });

  // Initialize ATC button on page load
  const container = document.querySelector('.product-single__meta');
  if (container) {
    logger.info("Found product form, initializing ATC button");
    initializeAddToCartButton(container);
  } else {
    logger.info("No product form found on page load");
  }

  // Initialize existing style options on page load
  const existingStyleOptions = document.querySelectorAll(".custom-style-option");
  if (existingStyleOptions.length > 0) {
    logger.info(`Found existing style options on page: ${existingStyleOptions.length}`);
    const quickView = new CustomQuickView();
    quickView.initializeStyleOptions(existingStyleOptions, document);
  } else {
    logger.info("No existing style options found on page");
  }

  waitForSwiper(function(){

    var ugcSweiperVideoSlider = new Swiper('.ugc-video-section .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 20,
        slidesPerView: 4,
        roundLengths: true,
        loop: true,
        breakpoints: {
            1199: {
                slidesPerView: 3.3,
            },
            991: {
                slidesPerView: 3.3,
            },
            800: {
                slidesPerView: 2.6,
            },
            500: {
                slidesPerView: 1.2,
            },
        },
        pagination: {
            el: '.slider__pagination',
            clickable: true,
        },
    });

    var swiperOptions = {
      loop: false,
      autoplay:true,
      delay:0,
      slidesPerView: 'auto',
      speed: 5000,
      grabCursor: true,
      centeredSlides: false,
    };
    var swiper = new Swiper(".custom-swatch-slider", swiperOptions);
 });
  
  if(document.querySelectorAll(".custom-style-option").length > 0){
    // No need to hide color options here - handled by CustomColorOptions class
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const promo = urlParams.get('promo');
  /*const freeGiftIDs = [44685167198435,43818201481443];
  if(promo != null && promo !='' && promo == 198435){
    AddFreeGiftProduct(44685167198435);
  }else if(promo != null && promo !='' && promo == 481443){
    AddFreeGiftProduct(43818201481443);
  }*/

  const discountCode = urlParams.get('discount_code');
  if(discountCode != null && discountCode == theme.settings.auto_discount_code && theme.settings.enable_autodiscount_code == true){
    addDiscountCodeProduct();
  }

  // Initialize cart remove functionality
  // initializeCartRemove(); // Moved to custom-elements.js as CartRemove class
});

async function addDiscountCodeProduct() {
  const cartrequest = await fetch('/cart.js');
  const cart = await cartrequest.json();

  const matchedOncart = cart.items.filter(item => item.product_id == theme.settings.autodiscount_product);
  
    if(matchedOncart.length > 0){
       const discountResponse = applyAutoDiscountCode(theme.settings.auto_discount_code);
    }else{
      let formData = {
       'items': [{
        'id': theme.settings.autodiscount_product_v_id,
        'quantity': 1,
         "properties":{
           "_isDiscountProduct":1
         }
        }]
      };
      const requestData = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      setTimeout(function(){
         const discountResponse = applyAutoDiscountCode(theme.settings.auto_discount_code);
      },300); 
    }
}

async function applyAutoDiscountCode(discountCode){
  const url = `/checkout?discount=${discountCode}`;
  let redirectUrl = `/`;
  if(theme.settings.autodiscount_redirecturl != "" && theme.settings.autodiscount_redirecturl != null){
    redirectUrl = theme.settings.autodiscount_redirecturl;
  }
  try {
     const response = await fetch(url);
     window.location=redirectUrl;
  } catch (error) {
     window.location=redirectUrl;
  }
}

async function AddFreeGiftProduct(freeGiftID){
  
  const redirectUrl = `/collections/shop-all-v3-free-shears`;

  const cartrequest = await fetch('/cart.js');
  const cart = await cartrequest.json();

  const matchedOncart = cart.items.filter(item => item.id == freeGiftID);
  if(matchedOncart.length <= 0){
      let formData = {
       'items': [{
        'id': freeGiftID,
        'quantity': 1
        }]
      };
    const requestData = await  fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
    window.location=redirectUrl;
  }else{
     window.location=redirectUrl;
  }
}


// OCU Custom Upgrades
document.addEventListener("DOMContentLoaded", (event) => {
  const logger = createLogger(true, 'ocu', LOG_LEVEL);
  function addCartButton(ocuContainer) {
    const checkoutButton = ocuContainer.querySelector('.ocu-checkout-button');

    if (checkoutButton) {
      const cartLink = document.createElement('button');
      cartLink.textContent = 'Go To Cart';
      cartLink.type = 'button';
      cartLink.className = 'fd--ocu-cart-link';
      checkoutButton.parentNode.insertBefore(cartLink, checkoutButton.nextSibling);
      cartLink.setAttribute('onclick', 'window.location.href="/cart"; return false;');
    }
  }

  function addEcodriveBanner(ocuContainer) {
    const ecodriveBanner = document.querySelector('.fd--ocu-ecodrive-banner');
    if (!ecodriveBanner) {
      console.warn('Ecodrive banner not found');
      return;
    }
    const trustBadges = ocuContainer.querySelector('.trust-badges');
    if (trustBadges) {
      trustBadges.parentNode.insertBefore(ecodriveBanner, trustBadges);
    }
  }

  const waitForOCUContainer = setInterval(() => {
      const ocuContainer = document.querySelector('.ocu-cart-container');
      if (ocuContainer) {
          clearInterval(waitForOCUContainer);
          logger.info('OCU cart container found');
          addCartButton(ocuContainer);
          addEcodriveBanner(ocuContainer);
      }
  }, 100);

});

theme.CartPopup = function() {
  const logger = createLogger(true, 'cart-popup', LOG_LEVEL);
  logger.info("CRS CartPopupInit");
  var selectors = {
      drawer: "#CartPopup",
      form: "#CartPopupForm"
  };
  function CartPopup() {
    logger.info('CRS CartPopup');
    this.container = document.querySelector(selectors.drawer);
    this.drawer = new theme.Drawers("CartPopup","cart_popup");
    this.init();
  }
  return CartPopup.prototype = Object.assign({}, CartPopup.prototype, {
      init: function() {
          logger.info('CRS init');
          document.addEventListener("ajaxProduct:added", function(evt) {
            logger.info('CRS ajaxProduct:added', evt);
            
            const drawerScrollable = this.container.querySelector('.drawer__scrollable');
            if (drawerScrollable) {
              const product = evt.detail.product;
              const productHtml = `
                <div class="cart-item">
                  <img src="${product.image}" alt="${product.title}" class="cart-item__image">
                  <div class="cart-item__details">
                    <h3 class="cart-item__title">${product.title}</h3>
                    <p class="cart-item__price">
                      ${product.original_price && product.original_price > product.final_price ?
                        `<span class="product__price product__price--compare">${theme.Currency.formatMoney(product.original_price, theme.settings.moneyFormat)}</span>
                        <br>` :
                        ''}
                      <span class="product__price product__price--sale">${theme.Currency.formatMoney(product.final_price, theme.settings.moneyFormat)}</span>
                    </p>
                  </div>
                </div>
              `;
              drawerScrollable.insertAdjacentHTML('afterbegin', productHtml);
            }
            this.open();
          }
          .bind(this)),
          document.addEventListener("bundlr:productAdded", function() {
              // this.cartForm.buildCart(),
              this.open()
          }
          .bind(this)),
          document.addEventListener("cart:open", this.open.bind(this)),
          document.addEventListener("cart:close", this.close.bind(this))
      },
      open: function() {
          logger.info('CRS open');
          this.drawer.open(),
          theme.a11y.trapFocus({
              container: this.container,
              elementToFocus: this.container,
              namespace: "cartpopup_focus"
          })
      },
      close: function() {
          logger.info('CRS close');
          this.drawer.close(),
          theme.a11y.removeTrapFocus({
              container: this.container,
              namespace: "cartpopup_focus"
          })
      }
  }),
  CartPopup
}();

if (theme.settings.cartType === "popup") {
  new theme.CartPopup();
}

// Initialize ATC button
function initializeAddToCartButton(container) {
  const logger = createLogger(true, 'init', LOG_LEVEL);
  logger.info("Initializing ATC button");
  new CustomAddToCartButton(container);
}
